import { IAMAPI } from './API'
import memoize from 'memoizee'
import TeamRole from './models/TeamRole'
import {
  FindTeamRolesQuery,
  CreateTeamRolePayload,
  UpdateTeamRolePayload,
  TeamRoleDTO,
} from './dtos/team-role'
import { collection } from 'infra/collection'
import { CursorPaged, PrimeProps } from 'types/definitions'
import { Observable } from 'rxjs'
import Member from './models/Member'
import { GetCurrentMember } from './SessionStore'

export type PrimeTeamRole = (
  props: PrimeProps<TeamRoleDTO, 'id'>
) => TeamRole | undefined

export default class TeamRoleStore {
  teamRoles = collection<TeamRoleDTO, TeamRole>({
    create: () => new TeamRole(),
  })

  constructor(
    private api: IAMAPI,
    private getCurrentMember: GetCurrentMember,
    currentMember$: Observable<Member>
  ) {
    currentMember$.subscribe(async () => {
      // this.teamRoles.clear()
    })
  }

  forWorkspace(workspaceId: string) {
    return this.teamRoles.filter((x) => x.workspaceId === workspaceId)
  }

  async fetch(id: string) {
    return this.api.teamRoles.get(id).then((data) => this.teamRoles.set(data))
  }

  async find(query: FindTeamRolesQuery): Promise<CursorPaged<TeamRole>> {
    return this.api.teamRoles
      .find({
        ...query,
      })
      .then((page) => ({
        ...page,
        data: this.teamRoles.set(page.data),
      }))
  }

  async create(data: CreateTeamRolePayload) {
    return this.api.teamRoles
      .create({
        ...data,
      })
      .then((data) => this.teamRoles.set(data))
  }

  async update(data: UpdateTeamRolePayload) {
    return this.api.teamRoles
      .update(data)
      .then((data) => this.teamRoles.set(data))
  }

  async delete(id: string) {
    return this.api.teamRoles.delete(id).then(() => this.teamRoles.remove(id))
  }

  fetchTeamRolesForWorkspace = memoize(
    async (workspaceId: string) => {
      return this.find({ workspace_id: workspaceId })
    },
    {
      promise: true,
      length: 1,
    }
  )
}
